"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M12.95 3.69a1 1 0 0 0-1.9 0L9.473 8.528H4.4a1 1 0 0 0-.588 1.809l4.112 2.989-1.575 4.836a1 1 0 0 0 1.539 1.119L12 16.29l4.124 2.99a1 1 0 0 0 1.538-1.119l-1.575-4.836 4.112-2.99a1 1 0 0 0-.588-1.808h-5.086L12.951 3.69Zm-1.8 6.148L12 7.23l.85 2.608a1 1 0 0 0 .95.69h2.735l-2.211 1.607a1 1 0 0 0-.363 1.119l.848 2.603-2.222-1.61a1 1 0 0 0-1.175 0l-2.207 1.604.846-2.597a1 1 0 0 0-.363-1.119l-2.211-1.607H10.2a1 1 0 0 0 .95-.69Z",
    clipRule: "evenodd"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M18.667 21.978A12 12 0 1 1 5.333 2.024a12 12 0 0 1 13.334 19.954Zm-1.111-1.663A10 10 0 1 1 6.444 3.685a10 10 0 0 1 11.112 16.63Z",
    clipRule: "evenodd"
  })]
});